module.exports = __webpack_public_path__ + "packs/media/images/april-fools-03fe870a3f534854d0f9ae30dd54a874.jpg";